export default __webpack_public_path__ + "static/slide4-tablet-1804ab371e12eeff32f710770075b2e0.png";